import { useMemo } from "react";
import { GoogleMap, useLoadScript, Marker } from "@react-google-maps/api";
import './GoogleMapCss.scss';

function GoMap() {
    const { isLoaded } = useLoadScript({
        googleMapsApiKey: process.env.REACT_APP_API_URL,
    });

    if (!isLoaded) return <div>Loading...</div>;
    return <Map />;
}

function Map() {
    const center = useMemo(() => ({ lat: 40.38274472142402, lng: 49.87063699290826 }), []);

    return (
        <GoogleMap zoom={14} center={center} mapContainerClassName="map-container" >
            <Marker position={center} />
        </GoogleMap>
    );
}

export default GoMap;